import { render, staticRenderFns } from "./caigou.vue?vue&type=template&id=0474c8fb"
import script from "./caigou.vue?vue&type=script&lang=js"
export * from "./caigou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports